const TENDER_OFFER_STATUS_BADGE = {
  declined: 'light-red',
  invited: 'grey',
  offered: 'light-green',
  participating: 'light-green',
  read: 'orange',
};

export default TENDER_OFFER_STATUS_BADGE;
